import { ErrorTypeEnum } from '../../../main/constants/error-type.ts';
import { getLocaleUtil } from '../../../main/utils/locale.util.ts';
import { getSentryUtil } from '../../../main/utils/monitoring/sentry.util.ts';
import { getToasterUtil } from '../../../main/utils/toaster.util.ts';

import { checkWritingMutationRequest } from '../../requests/check-writing.mutation.ts';
import { CheckWritingEvaluation, CheckWritingInput, CheckWritingResult } from '../../types/check-writing.types.ts';

const ERROR_RESULT: CheckWritingResult = {
  storageKey: '',
  evaluation: CheckWritingEvaluation.INCORRECT,
};

export class SoundsWritingGraderUtil {
  private static _instance: SoundsWritingGraderUtil;

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  static get instance(): SoundsWritingGraderUtil {
    if (!SoundsWritingGraderUtil._instance) {
      SoundsWritingGraderUtil._instance = new SoundsWritingGraderUtil();
    }
    return SoundsWritingGraderUtil._instance;
  }

  /**
   * Grades the user's writing against a reference path.
   * @param input The grading input containing user path and reference path
   * @returns A promise that resolves to the grading result
   */
  async grade(input: CheckWritingInput): Promise<CheckWritingResult> {
    try {
      const result = await checkWritingMutationRequest(input);

      if (!result.success) {
        this.handleError(result.message);
        return ERROR_RESULT;
      }

      return result.data;
    } catch (error) {
      this.handleError(error);
      return ERROR_RESULT;
    }
  }

  private handleError(error?: unknown): void {
    const errorMessage = getLocaleUtil().select('learn:check_writing_failed');
    getToasterUtil().error(errorMessage);

    getSentryUtil().trackError(error instanceof Error ? error : new Error(errorMessage), {
      errorType: ErrorTypeEnum.CHECK_WRITING_ERROR,
    });
  }
}

export const getSoundsWritingGraderUtil = (): SoundsWritingGraderUtil => SoundsWritingGraderUtil.instance;
